export const zeroPad = (num, places) => String(num).padStart(places, '0')

export function uf_getDate(data = undefined) {
    var date;
    if (data === undefined) {
        date = new Date()
    } else {
        date = new Date(data.time * 1000);
    }
    const dateStr = date.getDate() + "/" + (zeroPad(date.getMonth() + 1, 2)) + " " + date.getHours() + ":" + zeroPad(date.getMinutes(), 2) + ":" + zeroPad(date.getSeconds(), 2) 
    return dateStr
}

export function uf_addTimeStr(data) {
    if (data.time === undefined) {
        data.time = "-";
    } else {
        const dateStr = uf_getDate(data)
        data.time = dateStr;
    }
}

export function uf_sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export function uf_timestamp(stringtime) {
  const isNumeric = (string) => /^[+-]?\d+(\.\d+)?$/.test(string);
  if (isNumeric(stringtime)) {
    let unix_timestamp = stringtime;
    var a = new Date(unix_timestamp * 1000);

    var month = ("0" + (a.getMonth() + 1)).slice(-2);
    var day = ("0" + a.getDate()).slice(-2);
    var hour = ("0" + a.getHours()).slice(-2);
    var min = ("0" + a.getMinutes()).slice(-2);

    var time = hour + ':' + min + "  " + day + "/" + month;
    return time;
  } else {
    return stringtime;
  }
}